// extracted by mini-css-extract-plugin
export var contained = "OneThirdTwoThirdContentTiles-module--contained--9519c";
export var onethirdtwothirdcontenttiles = "OneThirdTwoThirdContentTiles-module--onethirdtwothirdcontenttiles--5efd4";